
import { TreeNode as TreeNodeType } from '../../models/TreeModel';

import { RandomDotmSpinner } from '@/components/ui/RandomDotmSpinner';
interface TreeNodeLoadingProps {
  node: TreeNodeType;
  depth: number;
  skeletonCount?: number;
}

/**
 * Modern loading indicator for tree nodes.
 * Shows skeleton loaders while children are being fetched.
 */
export function TreeNodeLoading({ node, depth, skeletonCount = 3 }: TreeNodeLoadingProps) {
  const baseIndent = 12;
  const minIndent = 16;
  const indentation = depth === 0 ? minIndent : minIndent + depth * baseIndent;

  return (
    <div className="bg-background [box-shadow:none] [outline:none] animate-in fade-in-50 duration-150">
      {/* Loading indicator row with spinner */}
      <div
        className="flex items-center px-2 py-1.5 text-sm"
        style={{ paddingLeft: `${indentation}px` }}
      >
        <div className="flex items-center gap-2 text-muted-foreground">
          <RandomDotmSpinner size={13} className="opacity-90" />
          <span className="text-xs">{node.name || 'Loading...'}</span>
        </div>
      </div>
      {/* Skeleton placeholder rows */}
      {Array.from({ length: skeletonCount }).map((_, index) => (
        <div
          key={index}
          className="flex items-center px-2 py-1 text-sm"
          style={{
            paddingLeft: `${indentation + 12}px`,
          }}
        >
          <div className="flex items-center gap-2 w-full">
            {/* Skeleton icon */}
            <div
              className="h-4 w-4 rounded bg-muted/60 animate-pulse"
              style={{ animationDelay: `${index * 75}ms` }}
            />
            {/* Skeleton text - varying widths for natural look */}
            <div
              className="h-3 rounded bg-muted/60 animate-pulse"
              style={{
                width: `${80 + (index % 3) * 25}px`,
                animationDelay: `${index * 75 + 50}ms`
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
